import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import locale JSON files (generated by scripts/convert-translations.cjs)
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    pt: { translation: pt },
  },
  // Start in English; preferencesStore.onRehydrateStorage calls
  // i18next.changeLanguage() immediately after hydration to restore
  // the persisted locale. setLocale() calls it on every user change.
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'de', 'fr', 'it', 'pt'],
  // Use dot notation for keys like "nav.dashboard"
  keySeparator: '.',
  interpolation: {
    // React already escapes values
    escapeValue: false,
  },
});

// Amounts inside copy: `{{total, chf}}` renders 22680 as 22'680 (or 22 680 in French), so the
// locale string stays the one place that decides how a number reads.
i18n.services.formatter?.add('chf', (value, lng) =>
  new Intl.NumberFormat(lng || 'de-CH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0)
);

export default i18n;
